import { CountryAttributes } from "../attributes/country-attributes";
import Currency from "./Currency";
import BaseModel from "./BaseModel";
import { parseDate } from "../common/Hooks";
import { EnableStatus } from "../settings/EnableStatus";
import Country from "./Country";
import { OperatorAttributes } from "../attributes/operator-attributes";

export const DEFAULT_COUNTRY_DIAL_CODE = "+237";
export const DEFAULT_COUNTRY_ISO_CODE = "cm";

class Operator extends BaseModel {
  id: number;
  designation: string;
  code: string;
  activated_at?: Date | null;

  currency?: Currency;
  country?: Country;

  constructor(
    id: number = null,
    designation: string,
    code: string,
    currency: Currency = null,
    
    created_at?: Date | null,
    activated_at?: Date | null,
    country: Country = null
  ) {
    super(created_at);

    this.id = id;
    this.designation = designation;
    this.code = code;
    this.currency = currency;
    this.activated_at = activated_at;
    this.country = country;
   
  }

  static fromJson(json: OperatorAttributes): Operator | null {
    if (json === null || json === undefined) {
      return null;
    }

    return new Operator(
      json.id,
      json.designation,
      json.code,
      json.currency != null ? Currency.fromJson(json.currency) : null,
      parseDate(json.created_at),
      parseDate(json.activated_at)
    );
  }

  static defaultCountry(designation: string) {
    return new Country(
      designation,
      DEFAULT_COUNTRY_DIAL_CODE,
      DEFAULT_COUNTRY_ISO_CODE
    );
  }

  status = (): EnableStatus => {
    if (this.activated_at !== null) {
      return EnableStatus.activated;
    }
    return EnableStatus.deactivated;
  };
  
}

export default Operator;
